'use client';

import { Flex, freddyTheme, Typography } from '@coolblue-development/freddy';
import { CheckmarkCircled } from '@coolblue-development/icons';
import { Image } from '@coolblue-development/next-image/client';
import { useTranslation } from '@i18n/useTranslation';
import React from 'react';

export const GenericSuccessMessage = () => {
  const { t } = useTranslation('vacancyDetail.applicationForm.successMessage');

  return (
    <>
      <Flex direction='column' alignItems='center' gap={400}>
        <Flex direction='column' alignItems='center' gap={400}>
          <CheckmarkCircled size={32} color={freddyTheme.color.font.sentimentPositiveContrast} />
          <Typography
            variant='h2'
            textAlign='center'
            color={freddyTheme.color.font.sentimentPositiveContrast}
            marginBottom={0}
          >
            {t('title')}
          </Typography>
        </Flex>
        <Image
          imageId='597297'
          alt='Celebration with confetti'
          width={700}
          height={189}
          loading='lazy'
          fileCollection='content'
          objectFit='cover'
          sx={theme => ({
            [theme.breakpoint.maxWidth('md')]: {
              width: 343,
              height: 135
            }
          })}
        />
      </Flex>
      <Flex
        direction='column'
        alignItems='center'
        gap={200}
        py={{ xs: 400, md: 600 }}
        backgroundColor={freddyTheme.color.background.secondary}
        borderRadius={{ xs: 100, md: 200 }}
      >
        <Typography
          variant='h5'
          textAlign='center'
          marginBottom={0}
          sx={theme => ({
            [theme.breakpoint.maxWidth('md')]: {
              padding: `0 ${theme.spacing[300]}`
            }
          })}
        >
          {t('text')}
        </Typography>
        <Flex gap={100} direction='column' alignItems='center'>
          <Typography variant='caption' color={freddyTheme.color.font.base} marginBottom={0}>
            {t('additionalText')}
          </Typography>
        </Flex>
      </Flex>
    </>
  );
};
